import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import Input from "../../../components/Input";
import { RejectBgIcon } from "../../../utils/Icons";
import { rejectCategoryRequest } from "../../../store/Categories/actions";

const RejectCategoryRequest = ({
  open,
  closeModal,
  categoryInfo
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const lang = useSelector((state) => state.locale.lang);

  const {
    categories: {
      categoriesRequests: { rejectRequest }
    },
    shared
  } = messages[lang];

  const {
    values,
    setFieldValue,
    handleSubmit,
    setFieldTouched,
    dirty,
    isValid,
    touched,
    errors
  } = useFormik({
    initialValues: {
      rejectionReason: ""
    },
    validationSchema: Yup.object().shape(
      {
        rejectionReason: Yup.string()
          .max(200, "suggestedCategoryRejectionReasonMaxChar")
          .required("rejectionReasonRequired")
      },
      ["rejectionReason"]
    ),
    onSubmit: ({ rejectionReason }) => {
      dispatch(
        rejectCategoryRequest({
          data: {
            Id: categoryInfo?.id,
            Reason: rejectionReason?.trim()
          },
          navigate
        })
      );

      handleCloseModal();
    }
  });

  const handleCloseModal = () => {
    closeModal();
    setFieldValue("rejectionReason", "");
    setFieldTouched("rejectionReason", false);
  };

  const renderRejectionForm = () => (
    <form onSubmit={handleSubmit} noValidate>
      <Input
        id="rejectionReason"
        inputWrapperClass={"mt-3"}
        name="rejectionReason"
        label={rejectRequest.rejectionReason}
        placeholder={rejectRequest.typeHere}
        onChange={(value) => {
          if (!value || !!value.trim()) {
            const modifiedValue = value
              .replace(/\s\s/g, " ")
              .replace("\n\n", "\n");
            setFieldTouched("rejectionReason");
            setFieldValue("rejectionReason", modifiedValue);
          }
        }}
        value={values.rejectionReason}
        multiline
        rows={2}
        isInputHasErr={
          !!(touched.rejectionReason && errors.rejectionReason)
        }
        errMsg={errors.rejectionReason}
      />
    </form>
  );

  return (
    <Modal
      open={open}
      icon={<RejectBgIcon />}
      title={rejectRequest.title.replace(
        ":categoryName",
        categoryInfo?.name || ""
      )}
      content={renderRejectionForm()}
      confirmBtnTxt={shared.reject}
      cancelBtnTxt={shared.cancel}
      handleClose={handleCloseModal}
      handleCancel={handleCloseModal}
      disableConfirmBtn={!dirty || !isValid}
      handleConfirm={handleSubmit}
      confirmBtnProps={{ danger: true }}
    />
  );
};

export default RejectCategoryRequest;

RejectCategoryRequest.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  categoryInfo: PropTypes.object.isRequired
};
